import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SankhyaEnvelope} from './sankhya-gateway.service';

export interface LoteDisponivel {
    controle: string;
    estoque: number;
    codemp: number;
    codlocal: number;
}

export interface LoteAtribuido {
    sequencia: number;
    codProd: number;
    controle: string;
}

export interface LotesDisponiveisResponse {
    sucesso: boolean;
    lista: LoteDisponivel[];
}

export interface AtribuicaoAutomaticaLoteResponse {
    sucesso: boolean;
    atribuidos: LoteAtribuido[];
    erro?: string;
}

@Injectable({providedIn: 'root'})
export class LoteService {
    private readonly apiUrl = '/api/sankhya/lote';

    constructor(private readonly http: HttpClient) {
    }

    /** Lotes disponíveis em estoque para um produto, filtrados pela empresa do pedido. */
    buscarLotesDisponiveis(codProd: number, nuNota: number): Observable<SankhyaEnvelope<LotesDisponiveisResponse>> {
        return this.http.post<SankhyaEnvelope<LotesDisponiveisResponse>>(
            `${this.apiUrl}/disponiveis`, {codProd, nuNota}
        );
    }

    /** Atribui automaticamente (FIFO) o primeiro lote disponível para cada item com TIPCONTEST='L'. */
    atribuirLotesAutomaticos(nuNota: number): Observable<SankhyaEnvelope<AtribuicaoAutomaticaLoteResponse>> {
        return this.http.post<SankhyaEnvelope<AtribuicaoAutomaticaLoteResponse>>(
            `${this.apiUrl}/atribuir-automatico`, {nuNota}
        );
    }

    /** Altera o lote de um item específico do pedido (grava CONTROLE e CODLOCALORIG em TGFITE). */
    alterarLoteItem(nuNota: number, sequencia: number, controle: string, codLocal: number): Observable<SankhyaEnvelope<{
        sucesso: boolean
    }>> {
        return this.http.post<SankhyaEnvelope<{ sucesso: boolean }>>(
            `${this.apiUrl}/alterar-item`, {nuNota, sequencia, controle, codLocal}
        );
    }
}
